<template>
  <div class="gene-panel-info-dailog dialog col-block">
    <div class="info-container col-block">
      <div
        class="info-block"
        v-html="[
          $t('DIALOG.genePanelInfo.___info01'),
          $t('DIALOG.genePanelInfo.___info02')
        ].join(isMobile ? '<br>' : ' ')"
      ></div>
      <div
        class="info-block"
        v-html="[
          $t('DIALOG.genePanelInfo.___info03')
        ].join(isMobile ? '<br>' : ' ')"
      ></div>
    </div>
    <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
    <customForm
      :init="emailData"
      :layoutType="'grid'"
      :groupCount="6"
      :alerts="alerts"
      :forms="formOptions['field1']"
      @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateSendEmail() : ''">
        <span>{{ $t('COMMON.button.___enter') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import customForm from '../../components/tool/customForm.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import responsitive from '../../mixins/responsitive.vue'

export default {
  components: {
    customForm
  },
  mixins: [
    toastMethods,
    responsitive
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      emailData: {
        email: '',
        name: '',
        organization: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: this.$t('DIALOG.genePanelInfo.form.title.___name'),
            errorTitle: this.$t('DIALOG.genePanelInfo.form.errorTitle.___name'),
            value: 'name',
            type: 'input',
            grid: 6,
            placeholder: () => this.$t('DIALOG.genePanelInfo.form.placeholder.___name'),
            validate: 'required'
          },
          {
            title: this.$t('DIALOG.genePanelInfo.form.title.___organization'),
            errorTitle: this.$t('DIALOG.genePanelInfo.form.errorTitle.___organization'),
            value: 'organization',
            type: 'input',
            grid: 6,
            placeholder: () => this.$t('DIALOG.genePanelInfo.form.placeholder.___organization'),
            validate: 'required'
          },
          {
            title: this.$t('DIALOG.genePanelInfo.form.title.___email'),
            errorTitle: this.$t('DIALOG.genePanelInfo.form.errorTitle.___email'),
            value: 'email',
            type: 'input',
            grid: 6,
            placeholder: () => this.$t('DIALOG.genePanelInfo.form.placeholder.___email'),
            validate: 'required|email'
          }
        ]
      }
    }
  },
  methods: {
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.emailData)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateSendEmail () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.sendEmail()
      }
      this.onSubmit = false
    },
    async sendEmail () {
      this.$emit('changeModal', {}, { ...this.result })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/genePanelInfo.vue